import Button from "@/common/components/Button";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { SearchIcon } from "lucide-react";
import { objectiveActionsTableColumns } from "../../constants/objectiveActionsTableColumns.constant";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { useNavigate } from "react-router-dom";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { MaintenanceObjectiveActionsTransformer } from "../../services/maintenanceObjectiveActionsTransformer";
import { useMaintenanceObjectiveActions } from "../../hooks/useMaintenanceObjectiveActions";

const MaintenanceObjectiveActionsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const navigate = useNavigate();

  const [search, setSearch] = useDebounce(filterParams.search);

  const {
    data: maintenanceObjectiveActions,
    isPending: isMaintenanceObjectiveActionsPending,
    meta: maintenanceObjectiveActionsMeta,
    refetch: refetchMaintenanceObjectiveActions,
    error: maintenanceObjectiveActionsError = {} as any,
  } = useMaintenanceObjectiveActions({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: MaintenanceObjectiveActionsTransformer.tableTransformer(),
    }),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-156px)]"
      refetchFunction={refetchMaintenanceObjectiveActions}
      statusCode={maintenanceObjectiveActionsError?.status}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <TextField
            name="search"
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-xl"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
            }}
            value={filterParams.search}
          />

          <div className="flex items-center justify-between">
            <Button
              name="create"
              operationKlassToCheckPermission="Admin::Maintenance::ObjectiveActions::Create"
              onClick={() => navigate('create')}
              className="ml-auto"
            >
              Nova Ação
            </Button>
          </div>
        </div>

        <Table
          className="h-[calc(100vh-320px)]"
          columns={objectiveActionsTableColumns}
          rows={maintenanceObjectiveActions}
          page={Number(filterParams.page) || 1}
          totalPages={maintenanceObjectiveActionsMeta.total_pages}
          totalCount={maintenanceObjectiveActionsMeta.total}
          hasPagination
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          rowEmptyValue="--"
          isLoadingData={isMaintenanceObjectiveActionsPending}
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceObjectiveActionsList;
